import { render, staticRenderFns } from "./SurveyImprovementTable.vue?vue&type=template&id=13512213&scoped=true&"
import script from "./SurveyImprovementTable.vue?vue&type=script&lang=js&"
export * from "./SurveyImprovementTable.vue?vue&type=script&lang=js&"
import style0 from "./SurveyImprovementTable.vue?vue&type=style&index=0&id=13512213&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13512213",
  null
  
)

export default component.exports